function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 100,
  height: 100,
  rx: 22,
  fill: "#F0C21E"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.4787 61.527H18.6854L16.4162 56.6797H12.2294L15.4787 61.527Z",
  fill: "#33343C"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M42.8591 65.8203C42.2519 60.7812 38.438 57.8835 33.3882 57.8835C27.6248 57.8835 23.2249 61.9531 23.2249 69.0909C23.2249 76.2074 27.5502 80.2983 33.3882 80.2983C38.9813 80.2983 42.3584 76.5803 42.8591 72.5639L38.1929 72.5426C37.7561 74.8757 35.9238 76.218 33.4628 76.218C30.1496 76.218 27.9017 73.7571 27.9017 69.0909C27.9017 64.5526 30.1176 61.9638 33.4948 61.9638C36.0196 61.9638 37.8414 63.4233 38.1929 65.8203H42.8591Z",
  fill: "#33343C"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M56.8029 64.4567H61.2241C61.1602 60.5682 57.9642 57.8835 53.1062 57.8835C48.3228 57.8835 44.8179 60.5256 44.8392 64.4886C44.8285 67.706 47.0977 69.549 50.7838 70.4332L53.1595 71.0298C55.5352 71.6051 56.8562 72.2869 56.8669 73.7571C56.8562 75.3551 55.3434 76.4418 52.9997 76.4418C50.6027 76.4418 48.8768 75.3338 48.7277 73.1499H44.2639C44.3811 77.8693 47.7582 80.3089 53.0529 80.3089C58.3797 80.3089 61.5118 77.7628 61.5224 73.7678C61.5118 70.1349 58.7738 68.2067 54.9812 67.3544L53.021 66.8857C51.1247 66.4489 49.5373 65.7457 49.5693 64.1797C49.5693 62.7734 50.8157 61.7401 53.0742 61.7401C55.2795 61.7401 56.6325 62.7415 56.8029 64.4567Z",
  fill: "#33343C"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M75.2612 64.4567H79.6823C79.6184 60.5682 76.4224 57.8835 71.5644 57.8835C66.781 57.8835 63.2761 60.5256 63.2974 64.4886C63.2867 67.706 65.5559 69.549 69.242 70.4332L71.6177 71.0298C73.9934 71.6051 75.3144 72.2869 75.3251 73.7571C75.3144 75.3551 73.8016 76.4418 71.4579 76.4418C69.0609 76.4418 67.335 75.3338 67.1859 73.1499H62.7221C62.8393 77.8693 66.2164 80.3089 71.5112 80.3089C76.8379 80.3089 79.97 77.7628 79.9806 73.7678C79.97 70.1349 77.232 68.2067 73.4394 67.3544L71.4792 66.8857C69.5829 66.4489 67.9955 65.7457 68.0275 64.1797C68.0275 62.7734 69.2739 61.7401 71.5325 61.7401C73.7377 61.7401 75.0907 62.7415 75.2612 64.4567Z",
  fill: "#33343C"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M87.4658 61.527H90.6725L88.4033 56.6797H84.2165L87.4658 61.527Z",
  fill: "#33343C"
});

function SvgCss(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.a5d1ce5d.svg";
export { ForwardRef as ReactComponent };